module.exports = __webpack_public_path__ + "img/ANTENNA 4 BW.17313a3.svg";